import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';

const GetAllCourses = () => {
  const url = apiConstants.GetAllCourses;

  return httpClient.get(url).then(result => result.data.result.items);
};

const GetCourse = (id) => {
  const url = `${apiConstants.GetCourse}?Id=${id}`;

  return httpClient.get(url).then(result => result.data.result.items);
};

const GetCoursesByClub = (id) => {
  const url = `${apiConstants.GetAllCourses}?Keyword=${id}&SkipCount=0&MaxResultCount=100000`;

  return httpClient.get(url).then(result => result.data.result.items);
};

export { GetAllCourses, GetCourse, GetCoursesByClub };
